import { render, staticRenderFns } from "./PolicyContainer.vue?vue&type=template&id=1702415f&"
import script from "./PolicyContainer.vue?vue&type=script&lang=ts&"
export * from "./PolicyContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports